import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=c96c1472&scoped=true&"
import script from "./Destination.vue?vue&type=script&lang=ts&"
export * from "./Destination.vue?vue&type=script&lang=ts&"
import style0 from "./Destination.vue?vue&type=style&index=0&id=c96c1472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96c1472",
  null
  
)

export default component.exports